import { getUserId } from "@/services/supabase/auth/actions/getUserId";
import { supabase } from "@/services/supabase/createClient";

export const setFormData = async (formName: string, formData: Record<string, any>): Promise<void> => {
  const userId = await getUserId();
  const { error } = await supabase.from("user_forms").upsert({
    user_id: userId,
    form_type: formName,
    form_data: formData,
  });

  if (error) {
    throw new Error("Failed to update form data");
  }
};
